"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgSttNexusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "21",
    fill: "#0A6FB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.363 27.3659C18.7873 27.2171 18.2006 27.5324 17.9989 28.0784L17.964 28.1905C17.8053 28.8045 18.1745 29.4309 18.7886 29.5895L18.9035 29.6132C19.4406 29.6954 19.9644 29.3866 20.1527 28.8769L20.1876 28.7649C20.3363 28.1892 20.0211 27.6025 19.475 27.4008L19.363 27.3659ZM19.5444 26.6634C20.5463 26.9222 21.1488 27.9445 20.89 28.9463C20.6312 29.9482 19.609 30.5507 18.6071 30.2919C17.6053 30.0331 17.0027 29.0109 17.2615 28.009C17.5203 27.0071 18.5426 26.4046 19.5444 26.6634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7235 23.0371C28.5764 23.6132 28.8932 24.199 29.4398 24.3992L29.552 24.4338C30.1664 24.5908 30.7918 24.2199 30.9487 23.6054L30.9721 23.4904C31.0528 22.953 30.7426 22.4301 30.2324 22.2432L30.1202 22.2086C29.5441 22.0615 28.9583 22.3783 28.7581 22.9249L28.7235 23.0371ZM28.0206 22.8576C28.2766 21.855 29.2972 21.2496 30.2998 21.5057C31.3023 21.7617 31.9077 22.7823 31.6517 23.7849C31.3956 24.7875 30.375 25.3928 29.3724 25.1368C28.3699 24.8807 27.7645 23.8601 28.0206 22.8576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7178 12.6954L22.2851 10.636",
    stroke: "white",
    "stroke-width": "1.46871"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "22.0997",
    cy: "20.7181",
    rx: "3.84848",
    ry: "3.84848",
    transform: "rotate(90 22.0997 20.7181)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3905 11.7003C25.2508 11.7001 25.9481 11.002 25.9481 10.1417C25.948 9.28147 25.2507 8.58416 24.3905 8.584C23.5837 8.584 22.9201 9.19731 22.8405 9.98312L22.8318 10.1417C22.8318 10.9484 23.4453 11.6119 24.2309 11.6917L24.3905 11.7003ZM24.3905 12.6843C22.9866 12.6843 21.8478 11.5456 21.8478 10.1417C21.848 8.73792 22.9867 7.60001 24.3905 7.60001C25.7941 7.60017 26.932 8.73802 26.9321 10.1417C26.9321 11.5455 25.7942 12.6841 24.3905 12.6843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9117 17.5977C22.9117 17.2707 23.6122 13.8958 24.0988 12.2414",
    stroke: "white",
    "stroke-width": "1.46871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2229 30.3583C29.6505 29.716 28.6654 29.6595 28.0229 30.2317C27.3807 30.804 27.3237 31.7885 27.8957 32.4309C28.4323 33.0334 29.3317 33.1211 29.9714 32.6579L30.0956 32.5589C30.698 32.0224 30.7855 31.1229 30.3225 30.4832L30.2229 30.3583ZM30.9577 29.7039C31.8914 30.7522 31.7984 32.36 30.75 33.2937C29.7016 34.2272 28.0946 34.1337 27.1609 33.0854C26.2275 32.0371 26.3204 30.4306 27.3685 29.4969C28.4168 28.5633 30.0239 28.6557 30.9577 29.7039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8286 29.6119L22.0119 20.3134",
    stroke: "white",
    "stroke-width": "1.46871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6984 22.9053L18.8692 21.8011",
    stroke: "white",
    "stroke-width": "1.46871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7118 24.7907C11.542 25.0165 12.3982 24.526 12.6242 23.6959C12.85 22.8658 12.3603 22.0099 11.5303 21.7838C10.7518 21.5719 9.95045 21.9894 9.66727 22.7267L9.61728 22.8774C9.40542 23.6558 9.82309 24.4572 10.5602 24.7405L10.7118 24.7907ZM10.4534 25.7402C9.09881 25.3715 8.29912 23.9736 8.66783 22.619C9.03666 21.2646 10.4342 20.4657 11.7887 20.8344C13.1431 21.2032 13.9421 22.5999 13.5736 23.9543C13.205 25.3088 11.8079 26.1087 10.4534 25.7402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5304 27.202L21.2998 21.9511",
    stroke: "white",
    "stroke-width": "1.46871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5592 22.8703L23.3034 21.1154",
    stroke: "white",
    "stroke-width": "1.46871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5432 17.4284L22.9117 20.1051",
    stroke: "white",
    "stroke-width": "1.46871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2548 14.9116L19.3496 18.4736",
    stroke: "white",
    "stroke-width": "1.46871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9297 14.9119C15.79 14.9118 16.4873 14.2136 16.4873 13.3533C16.4872 12.4931 15.7899 11.7958 14.9297 11.7956C14.1229 11.7956 13.4593 12.4089 13.3797 13.1947L13.371 13.3533C13.371 14.16 13.9845 14.8235 14.7702 14.9033L14.9297 14.9119ZM14.9297 15.8959C13.5258 15.8959 12.387 14.7572 12.387 13.3533C12.3872 11.9495 13.5259 10.8116 14.9297 10.8116C16.3333 10.8118 17.4712 11.9496 17.4713 13.3533C17.4713 14.7571 16.3334 15.8958 14.9297 15.8959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2555 15.824C29.6771 16.4609 29.7248 17.4465 30.3615 18.0251C30.9983 18.6034 31.9833 18.5563 32.5619 17.9197C33.1044 17.3226 33.0968 16.4191 32.5687 15.8317L32.4572 15.7187C31.8602 15.1762 30.9565 15.184 30.3692 15.7118L30.2555 15.824ZM29.5272 15.1623C30.4713 14.1233 32.0799 14.0463 33.1189 14.9904C34.1578 15.9345 34.2342 17.5425 33.2901 18.5815C32.3461 19.6202 30.7387 19.6971 29.6998 18.7533C28.6608 17.8093 28.5833 16.2013 29.5272 15.1623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5638 28.9503L26.6711 31.177",
    stroke: "white",
    "stroke-width": "1.46871"
  }));
}
var _default = exports["default"] = SvgSttNexusIcon;